import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'

import DialogProfileKeywordSetting from '@/client/components/_organisms/DialogProfileKeywordSetting.vue'
import ProfileKeywordSettingTable from '@/client/components/_organisms/ProfileKeywordSettingTable.vue'
import { useProfileKeywordSettingStore } from '@/client/store/useProfileKeywordSettingStore'

type DialogOpenOptions = {
  is_copy?: boolean
  setting_id?: number
}

type DialogProfileKeywordSettingRef = {
  open: (options: DialogOpenOptions) => void | Promise<void>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileKeywordSettingLayout',
  setup(__props) {

const profileKeywordSettingStore = useProfileKeywordSettingStore()
const dialogProfileKeywordSettingRef = ref<DialogProfileKeywordSettingRef | null>(null)

const openDialog = (options: DialogOpenOptions) => {
  dialogProfileKeywordSettingRef.value?.open(options)
}

/**
 * キーワード判定セットの追加
 */
const onAdd = () => {
  openDialog({ is_copy: false })
}

/**
 * プロファイルのキーワード設定を編集
 */
const onEdit = (setting_id: number) => {
  openDialog({ setting_id, is_copy: false })
}

/**
 * プロファイルのキーワード設定をコピー
 */
const onCopy = (setting_id: number) => {
  openDialog({ setting_id, is_copy: true })
}

onMounted(async () => {
  await profileKeywordSettingStore.fetchProfileKeywords()
})

return { __sfc: true,profileKeywordSettingStore, dialogProfileKeywordSettingRef, openDialog, onAdd, onEdit, onCopy, DialogProfileKeywordSetting, ProfileKeywordSettingTable }
}

})